import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";

import _  from 'underscore';
import "survey-react/survey.css";
import "./profile.css"

class website extends Component {


  constructor(props){
    super(props)
    this.state = {
     
     };
     
    
    }

  render() {

    
    return (
                <div className="company-profile"> 
                    <div></div>
                    
                </div>
            )
        }
    }    
  export default  website ;      






// WEBPACK FOOTER //
// ./src/component/company/website.js